<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-info-circle"></i>&nbsp;<ng-container i18n>Message Details</ng-container></h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <ul *ngIf="details">
    <li *ngIf="details.from">
      <b><ng-container i18n>From:</ng-container></b> {{ details.from }}
    </li>
    <li *ngIf="details.to">
      <b><ng-container i18n>To:</ng-container></b> {{ details.to }}
    </li>
    <li *ngIf="details.cc"><b>CC:</b> {{ details.cc }}</li>
    <li *ngIf="details.bcc"><b>BCC:</b> {{ details.bcc }}</li>
    <li *ngIf="details.receivedOn">
      <b><ng-container i18n>Date:</ng-container></b> {{ details.receivedOn | epoch }}
    </li>
    <li *ngIf="details.subject">
      <b><ng-container i18n>Subject:</ng-container></b> {{ details.subject }}
    </li>
    <li *ngIf="details.id"><b>Id:</b> {{ details.id }}</li>
    <li *ngIf="details.status">
      <b><ng-container i18n>Delivery Status:</ng-container></b> {{ details.status }}
    </li>
    <li *ngIf="details.readAt">
      <b><ng-container i18n>Read:</ng-container></b> {{ details.readAt | epoch }}
    </li>
    <li *ngIf="details.editedAt">
      <b><ng-container i18n>Edited:</ng-container></b> {{ details.editedAt | epoch }}
    </li>
    <li *ngIf="details.unsentAt">
      <b><ng-container i18n>Unsent:</ng-container></b> {{ details.unsentAt | epoch }}
    </li>
    <li>
      <b><ng-container i18n>Spam Score:</ng-container></b> {{ details.spamScore }} ({{
        details.spamFlag == 'Yes' ? 'Spam Found' : 'Spam Not Found'
      }})
    </li>
  </ul>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Close</ng-container>
  </button>
</div>
